
































import { Component, Prop, Vue } from 'vue-property-decorator';
import VueScrollTo from 'vue-scrollto';

@Component
export default class Slider extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<Array<any>>;

  curr: number = 0;

  naviHendler(value: number) {
    this.curr = value;
    this.scrollToTop();
  }

  scrollToTop() {
    VueScrollTo.scrollTo('body', 500, {
      easing: 'ease-in-out',
    });
  }

  prevHendler() {
    if (this.curr > 0) {
      this.curr = this.curr - 1;
      this.scrollToTop();
    }
  }

  nextHendler() {
    if (this.curr < this.items.length - 1) {
      this.curr = this.curr + 1;
      this.scrollToTop();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/slider/Slider.vue